import { useQueryParameters } from '@/hooks/useQueryParameters';
import useRequestFormStore from '../store';
import AddEpisodeButton from './AddEpisodeButton';

import DiseaseEpisode from './DiseaseEpisode';

interface DiseaseEpisodeListProps {
	diseaseId: string;
	isCancerTypeLateral: boolean;
  allowAdd: boolean;
}

const DiseaseEpisodeList = ({ diseaseId, isCancerTypeLateral, allowAdd }: DiseaseEpisodeListProps) => {
  const episodes = useRequestFormStore((store) => store.diseases?.[diseaseId]?.episodes);
  const orderedEpisodes = Object.keys(episodes ?? {}).sort((a, b) => {
    return episodes[a].order - episodes[b].order;
  });
  const queryParams = useQueryParameters();
  const isInAutosave = queryParams.has('patientId') && queryParams.has('eventId');
  const hasUnsavedEpisodes = Object.keys(episodes ?? {}).some((key) => !episodes[key].isSaved);

  return (
    <div className="col-span-2 sm:col-span-7">
      {orderedEpisodes.map((key) => (
        <DiseaseEpisode
          isTarget={episodes[key].isTargetEpisode}
          diagnosisStatus={episodes[key].diagnosisStatus}
          isSaved={episodes[key].isSaved}
          isCancerTypeLateral={isCancerTypeLateral}
          key={key}
          id={key}
          diseaseId={diseaseId}
        />
      ))}
      {allowAdd && <AddEpisodeButton
        isInAutosave={isInAutosave}
        diseaseId={diseaseId}
        hasUnsavedEpisodes={hasUnsavedEpisodes}
      />}
    </div>
  );
};

export { DiseaseEpisodeList as default };
